import { render, staticRenderFns } from "./StudentScheduleModal.vue?vue&type=template&id=1f3eda13&"
import script from "./StudentScheduleModal.vue?vue&type=script&lang=js&"
export * from "./StudentScheduleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports